import { useState } from "react";

export default function TextInput(props) {
    const [secureVisible, setSecureVisible] = useState(false);

    const align = props.align || "left";
    const alignProperties = {
        center: {
            containerClassName: "flex justify-center items-center",
            inputClassName: "text-center",
            bubblePlaceholderClassName: "",
        },
        left: {
            containerClassName: "flex justify-start items-start",
            inputClassName: "text-left",
            bubblePlaceholderClassName: "left-5",
        },
        right: {
            containerClassName: "flex justify-end items-end",
            inputClassName: "text-right",
            bubblePlaceholderClassName: "right-5",
        },
    };

    return (
        <div className={`relative flex w-full min-w-0 flex-col gap-2 ${alignProperties[align].containerClassName} ${props.xlassName || ""}`}>
            <label className={`text-sm font-bold md:text-base ${props.color}`}>{props.placeholder}</label>

            <div className="relative w-full min-w-0">
                <input
                    type={props.secureTextEntry && !secureVisible ? "password" : (props.type || "text")}
                    className={`min-h-[52px] w-full min-w-0 rounded-xl border px-4 py-3 pr-12 transition-all focus:outline-none focus:ring ${
                        props.disabled ? "bg-gray-100 text-gray-400" : "text-black"
                    } ${props.error ? "border-red-500" : "border-gray-300"} ${alignProperties[align].inputClassName}`}
                    disabled={props.disabled}
                    value={props.value || ""}
                    onChange={(e) => props.onChangeText?.(props.onlyNumber ? e.target.value.replace(/[^0-9]/g, "") : e.target.value)}
                    maxLength={props.maxLength}
                />

                {props.secureTextEntry && props.value !== "" && (
                    <button
                        type="button"
                        className="absolute right-1.5 top-1.5 flex size-10 items-center justify-center rounded-lg bg-black/5 text-neutral-600 opacity-75"
                        onMouseDown={() => setSecureVisible(true)}
                        onMouseUp={() => setSecureVisible(false)}
                        onMouseLeave={() => setSecureVisible(false)}
                    >
                        <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                    </button>
                )}
            </div>

            {/* Error Message */}
            {props.error && !props.disableErrorMessage && <p className="text-red-500 text-xs">{props.error}</p>}
        </div>
    );
}
